export default __webpack_public_path__ + "images/G2.a5e99e5.png";